import React from 'react';
import { Spinner, Container } from 'react-bootstrap';

interface LoaderProps {
  message?: string;
  size?: 'sm';  // Only 'sm' is allowed here for the Spinner size
}

const Loader: React.FC<LoaderProps> = ({ message = 'Loading...', size = 'sm' }) => {
  return (
    <Container
      className="d-flex justify-content-center align-items-center"
      style={{ height: '100vh' }}
    >
      <div className="text-center">
        <Spinner animation="border" role="status" size={size} />
        <div className="mt-3">{message}</div>
      </div>
    </Container>
  );
};

export default Loader;
